'use client'
import { __awaiter } from '../../../_virtual/_tslib.js';
import { ViemUiTransaction } from '../ViemUiTransaction/ViemUiTransaction.js';

const createViemUiTransaction = ({ from, publicClient, walletClient, }) => new ViemUiTransaction({
    account: from,
    onSubmit: (transaction) => __awaiter(void 0, void 0, void 0, function* () {
        return walletClient.sendTransaction({
            account: from,
            maxFeePerGas: transaction.maxFeePerGas,
            maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
            to: transaction.to,
            value: transaction.value,
        });
    }),
    publicClient,
    transaction: {},
});

export { createViemUiTransaction };
